import { Link, type LinkProps } from "react-router-dom"
import { useLocation } from "react-router-dom"
import { shouldOpenEspaceProInNewTab } from "@/lib/utils"

function resolveToPath(to: LinkProps["to"]): string {
  if (typeof to === "string") {
    return to
  }
  if (to && typeof to === "object" && "pathname" in to && to.pathname) {
    return to.pathname
  }
  return ""
}

export function AppLink({ to, target, rel, ...props }: LinkProps) {
  const { pathname } = useLocation()
  const openInNewTab = shouldOpenEspaceProInNewTab(pathname, resolveToPath(to))

  return (
    <Link
      to={to}
      target={openInNewTab ? "_blank" : target}
      rel={openInNewTab ? "noopener noreferrer" : rel}
      {...props}
    />
  )
}
